module.exports = __webpack_public_path__ + "img/360-matsal 2.bcd1169a.jpg";